import BannerDesktop from '../Images/Homepage/homepage-desktop.jpg';
import BannerMobile from '../Images/Homepage/homepage4.jpg';
import HomepageSecImage1 from '../Images/Homepage/homepage1.jpg';
import HomepageSecImage2 from '../Images/Homepage/homepage4.jpg';
import HomepageSecImage3 from '../Images/Homepage/homepage5.jpg';

function Home() {
    return(
        <div>
            {/* homepage banner */}
            <div className="section-image">
                <img className="hidden-xs hidden-sm" style={{width:"100%"}} src={BannerDesktop} alt="Banner Desktop"/>
                <img className="visible-xs visible-sm" style={{width:"100%"}} src={BannerMobile} alt="Banner Desktop"/>
                <div className="section-title">
                    <p className="visible-xs visible-sm" id="homepage-text">Martin Mechanical</p>
                    <p className="hidden-xs hidden-sm" id="homepage-text-large">Martin Mechanical</p>
                    <br/>
                    <p id="homepage-bottom-text">Reliable. Professional. Built to last.</p>
                </div>
            </div>
            {/* sections */}
            <div className="visible-sm visible-xs">
                <div style={{width:"100%", margin:"auto"}} id="box-search">
                    <div className="section-image">
                        <img className="section-div" src={HomepageSecImage1} alt="Homepage Section 1"/>
                        <div className="section-title">
                            <a href="/services"><p className="section-text">Services</p></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="visible-sm visible-xs">
                <div style={{width:"100%", margin:"auto"}} id="box-search">
                    <div className="section-image">
                        <img className="section-div" src={HomepageSecImage2} alt="Homepage Section 1"/>
                        <div className="section-title">
                            <a href="/about"><p className="section-text">About Us</p></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="visible-sm visible-xs">
                <div style={{width:"100%", margin:"auto"}} id="box-search">
                    <div className="section-image">
                        <img className="section-div" src={HomepageSecImage3} alt="Homepage Section 2"/>
                        <div className="section-title">
                            <a href="/contact"><p className="section-text">Contact</p></a>
                        </div>
                    </div>
                </div>
            </div>
            {/* Desktop */}
            <div className="container">
                <div className="box hidden-sm hidden-xs">
                    <div style={{width:"100%"}} id="box-search">
                        <div className="section-image">
                            <img className="section-div" src={HomepageSecImage1} alt="Homepage Section 1"/>
                            <div className="section-title">
                                <a href="/services"><p className="section-text">Services</p></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="box hidden-sm hidden-xs">
                    <div style={{width:"100%"}} id="box-search">
                        <div className="section-image">
                            <img className="section-div" src={HomepageSecImage2} alt="Homepage Section 1"/>
                            <div className="section-title">
                                <a href="/about"><p className="section-text">About Us</p></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="box hidden-sm hidden-xs">
                    <div style={{width:"100%"}} id="box-search">
                        <div className="section-image">
                            <img className="section-div" src={HomepageSecImage3} alt="Homepage Section 1"/>
                            <div className="section-title">
                                <a href="/services"><p className="section-text">Services</p></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Home;